import { Button } from '@medusajs/ui';
import { useNavigate, useParams } from 'react-router-dom';

import signUpCompletedSvg from './sign_up_completed.svg';

export const PendingTemplate = () => {
  const navigate = useNavigate();
  const { countryCode } = useParams<{ countryCode: string }>();

  const handleGoHome = () => {
    navigate(`/${countryCode ?? 'tw'}`);
  };

  return (
    <div
      className="text-black-30 flex flex-col items-center"
      data-testid="login-pending-state-container"
    >
      <img
        className="mb-8"
        src={signUpCompletedSvg}
        width={200}
        height={200}
        alt="sign_up_completed"
      />

      <p className="mb-8 text-xl font-bold uppercase">
        感謝您註冊火星生技！您的帳戶目前正在審核中
      </p>
      <p>
        審核需一到三個工作天，一旦審核完成並獲得批准，我們將會發送確認郵件至您的註冊郵箱。
      </p>
      <p className="mb-6">
        如果您在等待過程中有任何疑問或需要協助，請隨時聯絡您的業務員。
      </p>
      <p className="mb-8">祝您有個美好的一天！</p>

      <Button
        className="bg-primary-50 mb-20 rounded-sm px-4 py-2 text-base font-bold shadow-none"
        onClick={handleGoHome}
        data-testid="login-pending-back-home-button"
      >
        回首頁
      </Button>
    </div>
  );
};
